import { PROMO_CAMPAIGN_BENEFIT_CODES, type PromoCampaignBenefitCode } from '~/types/loyaltyContract';

import { luxLoyaltyBenefitDescriptionMap } from '~/utils/luxLoyalty';

export interface PromoCampaignBenefitOption {
  code: PromoCampaignBenefitCode;
  label: string;
}

export function getPromoCampaignBenefitLabel(code: PromoCampaignBenefitCode): string {
  return luxLoyaltyBenefitDescriptionMap.get(code as App.LuxLoyaltyBenefitType) || code;
}

export function getPromoCampaignBenefitOptions(): Array<PromoCampaignBenefitOption> {
  return PROMO_CAMPAIGN_BENEFIT_CODES.map((code) => ({
    code,
    label: getPromoCampaignBenefitLabel(code),
  }));
}
